import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class ContactNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor() {
    super('CONTACT', _('label.contact'), AppRoute.InfoContact, _('a11y.link.contact'), 'ABOUT');
  }
}
